export const axiosType = {
    CLIENT: "CLIENT",
    EKYC: "EKYC",
    LOG: "LOG",
}

export const reduxVariableStatus = {
    LOADED: "LOADED",
    PENDING: "PENDING",
    FAILED: "FAILED",
}


export const LoadStatus = {
    NONE: 'none',
    LOADING: 'loading',
    LOADED: 'loaded',
    FAIL: 'FAIL',
};

export const TradeAuthType = {
    OTP: "5",
    PIN: "1",
    TOKEN: "2",
    MATRIX: "3",
    CTS: "4",
    SMARTOTP: "6"
};

export const Role = {
    CUSTOMER: "C",
    BROKER: "B"
}

export const SocketStatus = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    CONNECTING: 'connecting',
};

export const ALL_INDEXES = [
    { name: 'VNINDEX', subName: 'VN INDEX', title: 'VN-INDEX', code: 'HOSE', department: 'HOSE', collectionId: 'HOSE', searchKey: 'VNINDEX', isDefault: true },
    { name: 'VN30', subName: 'VN30', title: 'VN30-INDEX', code: '30', department: 'HOSE', collectionId: 'VN30', searchKey: 'VN30', isDefault: true },
    { name: 'HNXINDEX', subName: 'HNX INDEX', title: 'HNX-INDEX', code: 'HNX', department: 'HNX', collectionId: 'HNX', searchKey: 'HNXINDEX', isDefault: true },
    // { name: 'HNX30', subName: 'HNX30', title: 'HNX30-INDEX', code: 'HNX30', department: 'HNX', collectionId: 'HNX30', searchKey: 'HNX30', isDefault: true },
    { name: 'UPCOM', subName: 'UPCOM INDEX', title: 'UPCOM', code: 'UPCOM', department: 'HNX', collectionId: 'UPCOM', searchKey: 'UPCOM', isDefault: true },
    { name: 'VNMID', subName: 'VN MID', title: 'VNMID-INDEX', code: 'MID', department: 'HOSE', collectionId: 'MID', searchKey: 'VNMID', isDefault: false },
    { name: 'VN100', subName: 'VN100', title: 'VN100-INDEX', code: '100', department: 'HOSE', collectionId: '100', searchKey: 'VN100', isDefault: false },
    { name: 'VNSML', subName: 'VN SMALL CAP', title: 'VNSML-INDEX', code: 'SML', department: 'HOSE', collectionId: 'SML', searchKey: 'VNSML', isDefault: false },
    { name: 'VNXALL', subName: 'VNX ALL', title: 'VNXALL-INDEX', code: 'XALL', department: 'HOSE', collectionId: 'XALL', searchKey: 'VNXALL', isDefault: false },
    // { title: 'VNX50-INDEX', code: 'X50', department: 'HOSE', collectionId: 'X50', isDefault: false },
    // { title: 'VNSI-INDEX', code: 'SI', department: 'HOSE', collectionId: 'SI', isDefault: false },
    // { title: 'VNX200-INDEX', code: 'X200', department: 'HOSE', collectionId: 'X200', isDefault: false },
    { name: 'VNALL', subName: 'VN ALL SHARE', title: 'VNALL-INDEX', code: 'ALL', department: 'HOSE', collectionId: 'ALL', searchKey: 'VNALL', isDefault: false },
    { name: 'VNDIAMOND', subName: 'VN DIAMOND', title: 'DIAMOND-INDEX', code: 'DIAMOND', department: 'HOSE', collectionId: 'DIAMOND', searchKey: 'VNDIAMOND', isDefault: false },
    { name: 'VNFINLEAD', subName: 'VN FINLEAD', title: 'FINLEAD-INDEX', code: 'FINLEAD', department: 'HOSE', collectionId: 'FINLEAD', searchKey: 'VNFINLEAD', isDefault: false },
    { name: 'VNFINSELECT', subName: 'VN FIN SELECT', title: 'FINSELECT-INDEX', code: 'FINSELECT', department: 'HOSE', collectionId: 'FINSELECT', searchKey: 'VNFINSELECT', isDefault: false }
    // { title: 'HOSE-NEW-INDEX', code: 'NEW', department: 'HOSE', collectionId: 'HOSENEW', searchKey: 'VNNEW' }
]

export const EXCHANGE = { HOSE: 'HOSE', HNX: 'HNX', UPCOM: 'UPCOM', DERIVATIVE: 'XHNF' };

export const FILTER_SYMBOL_ID = {
    INDUSTRIES_EVENT: "INDUSTRIES_EVENT", // sự kiện quyền

    topChangeHNX: "TOP_GAIN_OF_HNX", // Top mã tăng giá
    topKeepHNX: "TOP_LOSS_OF_HNX", // Top mã giảm giá

    topChangeHOSE: "TOP_GAIN_OF_HOSE",
    topKeepHOSE: "TOP_LOSS_OF_HOSE",

    topChangeUPCOM: "TOP_GAIN_OF_UPCOM",
    topKeepUPCOM: "TOP_LOSS_OF_UPCOM"
}

export const CommonObject = {
    emptyObject: Object.freeze({}),
    emptyArray: Object.freeze([])
};

export const SymbolCollectionTypes = {
    WATCH_LIST: 'WATCH_LIST',
    EXCHANGE: 'EXCHANGE',
    PORTFOLIO: 'PORTFOLIO',
    FIXED_LIST: 'FIXED_LIST',
    TOP_INSTRUMENT: 'TOP_INSTRUMENT',
    INDUSTRY: 'INDUSTRY',
    CW: 'CW',
    BONDS: 'BONDS',
    PUTTHROUGH: 'PUTTHROUGH',
    INDEX: 'INDEX',
    IBROKER: 'IBROKER',
    DERIVATIVE: 'DERIVATIVE',
    RECOMMEND: 'RECOMMEND',
    ETF: 'ETF',
    ODDLOT: 'ODDLOT',
    CORPBOND: 'CORPBOND'
};

export const STOCKTYPE = { BOND: '1', ETF: '3', CW: '4', TPDN: '12' };

export const derivativeExchanges = ['XHNF'];

export const FLOOR_CODE = {
    HNX: '02',
    HOSE: '10',
    UPCOM: '04',
    VN30: '30',
    DERIVATIVE_INDEX: '03',
    HNX30: 'HNX30',
    VNXALLSHARE: '13',
    DERIVATIVE_VN30: 'DER01',
    DERIVATIVE: 'XHNF',
}

export const LIST_TAB_PB_ID: any = {
    HNX: { id: 'HNX', exchange: 'HNX' },
    HOSE: { id: 'HOSE', exchange: 'HOSE' },
    UPCOM: { id: 'UPCOM', exchange: 'UPCOM' },
    VN30: { id: 'VN30', exchange: 'VN30' },
    HNX_ODDLOT: { id: 'HNX_ODDLOT', exchange: 'HNX_ODDLOT' },
    HOSE_ODDLOT: { id: 'HOSE_ODDLOT', exchange: 'HOSE_ODDLOT' },
    UPCOM_ODDLOT: { id: 'UPCOM_ODDLOT', exchange: 'UPCOM_ODDLOT' },
}

export const formatNumberTypes = {
    ONE_DIGITS: '0,0.[0]',
    TWO_DIGITS: '0,0.[00]',       //get 2 digits after common
    THREE_DIGITS: '0,0.[000]',    //get 3 digits after common
};

export const COS_ROLE = {
    M: "M", // Master
    F: "F", // Follower
}

export const STATUS_ACCOUNT = {
    // Master - Follower
    A: "A", // active
    C: "C", //close
    WC: "WC" // wait close
}